import { Trans } from '@lingui/react'

import { Amount } from '@twisto/components/atoms/amount'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { Paper } from '@twisto/components/atoms/paper'
import { Typography } from '@twisto/components/atoms/typography'
import { BigMoneyIcon } from '@twisto/icons'

import { useFlow } from '../../flow/flow.context'

import * as styles from './review-income-step.styles'

export const ReviewIncomeStepHeader = () => {
  const { flow } = useFlow<'ReviewIncomeStep'>()
  const { currency, value } = flow.currentStep.calculatedMonthlyIncome

  return (
    <>
      <Headline css={styles.header}>
        <HeadlineIcon>
          <BigMoneyIcon color="primary" height="100%" width="100%" />
        </HeadlineIcon>
        <HeadlineTitle>
          <Trans id="flow.reviewIncomeStep.title" />
        </HeadlineTitle>
        <HeadlineSubtitle>
          <Trans id="flow.reviewIncomeStep.subtitle" />
        </HeadlineSubtitle>
      </Headline>
      <Paper noMargin noPadding css={styles.paper}>
        <Amount
          amount={value}
          currency={currency}
          size="medium"
          title={<Trans id="flow.reviewIncomeStep.amount.title" />}
        />
        <Typography color="textTertiary" variant="b3">
          <Trans id="flow.reviewIncomeStep.amount.subtitle" />
        </Typography>
        <Typography color="textTertiary" variant="b3">
          <Trans id="flow.reviewIncomeStep.amount.subtitle.second" />
        </Typography>
      </Paper>
    </>
  )
}
